(() => {
  const init = (root) => {
    if (!root || root.dataset.mhhReady === 'true') return;
    root.dataset.mhhReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-mhh-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-mhh-dot]'));
    const prev = root.querySelector('[data-mhh-prev]');
    const next = root.querySelector('[data-mhh-next]');
    const pause = root.querySelector('[data-mhh-pause]');
    const pauseLabel = root.querySelector('[data-mhh-pause-label]');
    const status = root.querySelector('[data-mhh-status]');
    if (!slides.length) return;
    let index = 0;
    let timer = 0;
    let touchX = 0;
    let manuallyPaused = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = root.dataset.autoplay === 'true' && !reduced;
    const interval = Math.max(5000, Number(root.dataset.interval || 7000));
    const setPauseUi = () => {
      if (!pause || !pauseLabel) return;
      const paused = manuallyPaused || !autoplayEnabled;
      pauseLabel.textContent = paused ? 'Play' : 'Pause';
      pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    };
    const show = (nextIndex, announce) => {
      const previousIndex = index;
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.tabIndex = 0;
      });
      if (announce && status) {
        const heading = slides[index]?.querySelector('.mz-home-hero__heading')?.textContent?.trim() || 'Slide';
        status.textContent = heading + ', slide ' + (index + 1) + ' of ' + slides.length;
      }
      root.dispatchEvent(new CustomEvent('muaazon:hero:change', {
        bubbles: true,
        detail: { index, previousIndex, slide: slides[index], previousSlide: slides[previousIndex] }
      }));
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = 0; };
    const start = () => {
      stop();
      if (!autoplayEnabled || manuallyPaused || document.hidden || slides.length < 2) return;
      timer = window.setInterval(() => show(index + 1, false), interval);
    };
    const userNavigate = (nextIndex) => { show(nextIndex, true); start(); };
    if (prev) prev.addEventListener('click', () => userNavigate(index - 1));
    if (next) next.addEventListener('click', () => userNavigate(index + 1));
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => userNavigate(i));
      dot.addEventListener('keydown', (event) => {
        let target = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = (i + 1) % dots.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = (i - 1 + dots.length) % dots.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = dots.length - 1;
        else return;
        event.preventDefault();
        userNavigate(target);
        dots[target].focus();
      });
    });
    if (pause) {
      pause.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        if (manuallyPaused) stop(); else start();
        setPauseUi();
      });
    }
    root.addEventListener('touchstart', (event) => {
      touchX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
      const dx = endX - touchX;
      if (Math.abs(dx) > 44) userNavigate(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    const onVisibility = () => { if (document.hidden) stop(); else start(); };
    document.addEventListener('visibilitychange', onVisibility);
    root.__mhhCleanup = () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      delete root.__mhhCleanup;
      delete root.dataset.mhhReady;
    };
    show(0, false);
    setPauseUi();
    start();
    root.dispatchEvent(new CustomEvent('muaazon:hero:ready', {
      bubbles: true,
      detail: { index, slide: slides[index] }
    }));
  };
  const mount = () => document.querySelectorAll('[data-mhh-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target && event.target.matches && event.target.matches('[data-mhh-root]') ? event.target : (event.target && event.target.querySelector ? event.target.querySelector('[data-mhh-root]') : null);
    if (root) { root.__mhhCleanup?.(); init(root); }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.matches && event.target.matches('[data-mhh-root]') ? event.target : (event.target && event.target.querySelector ? event.target.querySelector('[data-mhh-root]') : null);
    root?.__mhhCleanup?.();
  });
})();
